// components/Header.jsx
// Top navigation bar — matches CW Expense Manager aesthetic

import React from 'react';
import { useMsal } from '@azure/msal-react';
import logo from '../assets/CT.png';

export default function Header() {
  const { accounts, instance } = useMsal();
  const account = accounts[0];

  const handleSignOut = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <header style={{
      borderBottom: '1px solid var(--border)',
      padding: '0 1.5rem',
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      position: 'sticky',
      top: 0,
      background: 'rgba(3, 7, 18, 0.88)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      zIndex: 100,
    }}>
      <img src={logo} alt="CT" style={{ height: '28px', width: 'auto' }} />

      <div style={{
        width: '1px',
        height: '20px',
        background: 'var(--border-light)',
        flexShrink: 0,
      }} />

      <span style={{
        fontFamily: 'var(--font-display)',
        fontSize: '0.9rem',
        fontWeight: 600,
        color: 'var(--text-secondary)',
        letterSpacing: '0.01em',
      }}>
        Dashboard Hub
      </span>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {account && (
          <span style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.8rem',
            fontWeight: 500,
            color: 'var(--text-muted)',
          }}>
            {account.name || account.username}
          </span>
        )}
        <button
          onClick={handleSignOut}
          style={{
            background: 'none',
            border: '1px solid var(--border-light)',
            color: 'var(--text-muted)',
            fontFamily: 'var(--font-body)',
            fontSize: '0.7rem',
            fontWeight: 600,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            padding: '6px 14px',
            borderRadius: 'var(--radius)',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'var(--accent)';
            e.currentTarget.style.color = 'var(--accent)';
            e.currentTarget.style.background = 'var(--accent-soft)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'var(--border-light)';
            e.currentTarget.style.color = 'var(--text-muted)';
            e.currentTarget.style.background = 'none';
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
